/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 70d2f0aa (Mon Feb 23 19:51:14 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  LicensingPaymentDetails,
  LicensingPaymentDetailsFromJSON,
  LicensingPaymentDetailsToJSON,
  LicensingPayments,
  LicensingPaymentsFromJSON,
  LicensingPaymentsToJSON,
  PaginationResponse,
  PaginationResponseFromJSON,
  PaginationResponseToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchLicensingLcdPaymentsResponse
 */
export interface FetchLicensingLcdPaymentsResponse {
  /**
   *
   * @type {Array<LicensingPayments>}
   * @memberof FetchLicensingLcdPaymentsResponse
   */
  data: Array<LicensingPayments>
  /**
   *
   * @type {Array<LicensingPaymentDetails>}
   * @memberof FetchLicensingLcdPaymentsResponse
   */
  licensingPaymentsData?: Array<LicensingPaymentDetails>
  /**
   *
   * @type PaginationResponse
   * @memberof FetchLicensingLcdPaymentsResponse
   */
  pagination?: PaginationResponse
}

export function FetchLicensingLcdPaymentsResponseFromJSON(
  json: any
): FetchLicensingLcdPaymentsResponse {
  return FetchLicensingLcdPaymentsResponseFromJSONTyped(json, false)
}

export function FetchLicensingLcdPaymentsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchLicensingLcdPaymentsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(LicensingPaymentsFromJSON),
    licensingPaymentsData: !exists(json, 'licensingPaymentsData')
      ? undefined
      : (json['licensingPaymentsData'] as Array<any>).map(
          LicensingPaymentDetailsFromJSON
        ),
    pagination: !exists(json, 'pagination')
      ? undefined
      : PaginationResponseFromJSON(json['pagination']),
  }
}

export function FetchLicensingLcdPaymentsResponseToJSON(
  value?: FetchLicensingLcdPaymentsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(LicensingPaymentsToJSON),
    licensingPaymentsData:
      value.licensingPaymentsData === undefined
        ? undefined
        : (value.licensingPaymentsData as Array<any>).map(
            LicensingPaymentDetailsToJSON
          ),
    pagination: PaginationResponseToJSON(value.pagination),
  }
}
